import { SET_DROP_DOWN_ALERT_INFO } from "../actions/types";
import { isNative, isWeb } from "../styles/commonStyles";
import * as ImagePicker from "expo-image-picker";

export async function pickImage(dispatch) {
	const files = [];
	let value;

	if (isNative) {
		const { status } = await ImagePicker.requestMediaLibraryPermissionsAsync();
		if (status !== "granted") {
			dispatch({
				type: SET_DROP_DOWN_ALERT_INFO,
				info: "photosinfo"
			});
			return;
		}
	}
	let result = await ImagePicker.launchImageLibraryAsync({
		mediaTypes: "Images",
		quality: 0.1,
		base64: true
	});

	if (!result.canceled) {
		if (isWeb) {
			// Since expo-image-picker 17 (SDK 54) `uri` is a `blob:` URL on web, no
			// longer a data URL, so the upload must be built from `base64` (sent
			// without its data-URL prefix). `uri` stays the preview value.
			const asset = result.assets?.[0];
			const name = "" + Date.now();
			files.push({
				name,
				base64: `data:${asset?.mimeType || "image/jpeg"};base64,${
					asset?.base64
				}`
			});
			value = asset?.uri;
		} else {
			const filename = result.assets?.[0]?.uri.split("/").pop();
			const name = filename
				? filename.substring(0, filename.lastIndexOf("."))
				: "" + Date.now();
			files.push({
				name,
				base64: "data:image/jpeg;base64," + result.assets?.[0]?.base64
			});
			value = result.assets?.[0]?.uri;
		}
	}

	return {
		files,
		value
	};
}
